import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";
import { api, errText } from "../../lib/admin";

const upload = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd);
  return data.url;
};

const Picker = ({ onFile, busy, testId, label = "Carica foto" }) => {
  const ref = useRef(null);
  return (
    <>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" data-testid={`${testId}-input`}
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) onFile(f); }} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`${testId}-btn`}
        className="inline-flex items-center gap-2 rounded-full border border-[#ddd4c7] px-4 py-2 text-[0.72rem] tracking-[0.14em] uppercase text-[#14110F] hover:border-[#8A6A3A] transition-colors duration-200 disabled:opacity-50">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ImagePlus className="w-4 h-4" />} {busy ? "Caricamento…" : label}
      </button>
    </>
  );
};

const useUpload = () => {
  const [busy, setBusy] = useState(false);
  const run = async (file, done) => {
    if (file.size > 10 * 1024 * 1024) { toast.error("Immagine troppo grande (max 10 MB)"); return; }
    setBusy(true);
    try { done(await upload(file)); toast.success("Foto caricata"); } catch (e) { toast.error(errText(e, "Caricamento non riuscito")); }
    setBusy(false);
  };
  return [busy, run];
};

export const ImageField = ({ value, onChange, testId }) => {
  const [busy, run] = useUpload();
  return (
    <div className="flex items-center gap-4">
      <div className="w-24 h-28 rounded-lg overflow-hidden bg-[#efe9df] shrink-0 border border-[#e7dfd3]">
        {value && <img src={value} alt="" className="w-full h-full object-cover" data-testid={`${testId}-preview`} />}
      </div>
      <Picker busy={busy} testId={testId} onFile={(f) => run(f, onChange)} label={value ? "Cambia foto" : "Carica foto"} />
    </div>
  );
};

export const GalleryField = ({ value, onChange, testId }) => {
  const [busy, run] = useUpload();
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-3">
        {value.map((src, i) => (
          <div key={src} className="relative w-20 h-24 rounded-lg overflow-hidden bg-[#efe9df] border border-[#e7dfd3]">
            <img src={src} alt="" className="w-full h-full object-cover" />
            <button type="button" aria-label="Rimuovi foto" data-testid={`${testId}-remove-${i}`} onClick={() => onChange(value.filter((x) => x !== src))}
              className="absolute top-1 right-1 w-6 h-6 rounded-full bg-[#14110F]/80 text-white flex items-center justify-center hover:bg-[#9a3b2b]">
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>
      <Picker busy={busy} testId={testId} onFile={(f) => run(f, (url) => onChange([...value, url]))} label="Aggiungi foto" />
    </div>
  );
};
